import React, { useState, useEffect, useRef } from 'react';
import { Container, Row, Col, Button, Image, Card, Form, Badge, Accordion } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import { FaVideo, FaPhoneAlt, FaEye, FaRegHeart, FaShareAlt, FaRegPaperPlane } from "react-icons/fa";
import { useNavigate } from 'react-router-dom';
import BaseUrl from '../../ApiServices/BaseUrl';
import Navbar from '../../Pages/Navbar/Navbar';
import Footer from "../../Footer/Footer"
import GulfWorkerLeadBot from '../../LeadBot/GulfWorkerLeadBot';
import '../Candidates/Candidates.css';
import './Nurse.css';
import '../DomesticHelper/DomesticHelper.css';
import Swal from 'sweetalert2';
import Register from '../Candidates/Register';
import Login from '../Candidates/Login';
import defaultProfileImage from '../../Pages/Images/defaultimage.webp';
import moment from 'moment';
import SendAlertScrollPrompt from '../../Common/SendAlertPrompt/SendAlertScrollPrompt';
import { triggerSendAlertAction } from '../../Common/SendAlertPrompt/sendAlertAction';
import { 
  getVisibleOfferBadgeText, 
  getVisibleSourceLabel, 
  hasHighlightedSourceLabel, 
  hasVisibleOfferBadge,
  formatApplyForCountry
} from '../../../utils/candidateBadges';
import { HiOutlineBellAlert } from 'react-icons/hi2';
import CandidateCardHeading from '../../Common/CandidateCardHeading';

function Nurse({ healthcareType = 'nurse' }) {
    const PAGE_SIZE = 15;
    const isDoctorPage = healthcareType === 'doctor';
    const healthcarePageLabel = isDoctorPage ? 'Doctor' : 'Nurse';
    const healthcareLicenseLabel = isDoctorPage ? 'Doctor License' : 'Nursing License';
    const healthcareSearchPlaceholder = `Search by name, nationality, job position, or ${isDoctorPage ? 'doctor license' : 'nursing license'}`;
    const healthcarePageKey = isDoctorPage ? 'home-doctor' : 'home-nurse';
    const [candidates, setCandidates] = useState([]);
    const [filteredCandidates, setFilteredCandidates] = useState([]);
    const [loading, setLoading] = useState(true);
    const [loadingMore, setLoadingMore] = useState(false);
    const [error, setError] = useState(null);
    const navigate = useNavigate();
    const [showMoreJobPosition, setShowMoreJobPosition] = useState(true);
    const [showMoreJobType, setShowMoreJobType] = useState(false);
    const [showMoreLanguage, setShowMoreLanguage] = useState(false);
    const [showMoreMainSkills, setShowMoreMainSkills] = useState(false);
    const [showRegisterPopup, setShowRegisterPopup] = useState(false);
    const [showLoginPopup, setShowLoginPopup] = useState(false);
    const user = JSON.parse(localStorage.getItem('user')) || {};
    const [searchInput, setSearchInput] = useState('');
    const [searchTerm, setSearchTerm] = useState('');
    const autoSearchTimeoutRef = useRef(null);
    const isAutoSearchingRef = useRef(false);
    const [page, setPage] = useState(1);
    const [hasMore, setHasMore] = useState(false);
    const [visibleCount, setVisibleCount] = useState(9);

    const getCandidateKey = (candidate) =>
        candidate?.id || candidate?.user_id || candidate?.job_seeker_id || `${candidate?.email || ''}-${candidate?.phone_number || ''}`;

    const mergeUniqueCandidates = (existingCandidates, incomingCandidates) => {
        const uniqueCandidates = new Map();

        [...existingCandidates, ...incomingCandidates].forEach(candidate => {
            const candidateKey = getCandidateKey(candidate);
            if (!uniqueCandidates.has(candidateKey)) {
                uniqueCandidates.set(candidateKey, candidate);
            }
        });

        return Array.from(uniqueCandidates.values());
    };
    const [showLocation, setShowLocation] = useState(false);
    const [showContractStatus, setShowContractStatus] = useState(false);
    const [showPostedBy, setShowPostedBy] = useState(false);
    const [showStartDate, setShowStartDate] = useState(false);
    const [showFiltersMobile, setShowFiltersMobile] = useState(false);
    const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

    // Filter states
    const [jobPosition, setJobPosition] = useState({
        maid: false,
        driver: false,
        cook: false,
        nanny: false,
        nurse: false,
        houseboy: false,
        tailor: false,
        teacher: false,
        trainer: false,
        gardener: false,
        butler: false,
        housekeeper: false,
        laundryWorker: false,
        personalAssistant: false,
        caregiver: false,
        elderCareCompanion: false,
        petSitter: false,
        houseManager: false,
        cleaner: false,
        maintenanceWorker: false,
        babySitter: false,
        tutor: false,
        chauffeur: false,
        housemaid: false,
        kitchenStaff: false,
        diningRoomAttendant: false,
        personalChef: false,
        eventCoordinator: false,
        householdAdministrator: false,
        domesticAssistant: false
    });

    const [jobCountry, setJobCountry] = useState({
        qatar: false,
        uae: false,
        saudiArabia: false,
        kuwait: false,
        bahrain: false,
        oman: false,
        usa: false,
        canada: false,
        uk: false,
        australia: false,
        germany: false,
        france: false,
        italy: false,
        spain: false,
        netherlands: false,
        belgium: false,
        switzerland: false,
        sweden: false,
        norway: false,
        denmark: false,
        finland: false,
        japan: false,
        southKorea: false,
        singapore: false,
        malaysia: false,
        china: false,
        hongKong: false,
        newZealand: false,
        southAfrica: false,
        brazil: false,
        mexico: false,
        argentina: false,
        chile: false,
        colombia: false,
        peru: false,
        egypt: false,
        morocco: false,
        algeria: false,
        tunisia: false,
        jordan: false,
        lebanon: false,
        iraq: false,
        iran: false,
        turkey: false,
        cyprus: false,
        malta: false,
        greece: false,
        portugal: false,
        austria: false,
        hungary: false,
        poland: false,
        czechRepublic: false,
        slovakia: false,
        slovenia: false,
        croatia: false,
        romania: false,
        bulgaria: false,
        serbia: false,
        montenegro: false,
        albania: false,
        northMacedonia: false,
        bosniaHerzegovina: false,
        kosovo: false,
        estonia: false,
        latvia: false,
        lithuania: false,
        belarus: false,
        ukraine: false,
        moldova: false,
        georgia: false,
        armenia: false,
        azerbaijan: false,
        kazakhstan: false,
        uzbekistan: false,
        turkmenistan: false,
        kyrgyzstan: false,
        tajikistan: false,
        afghanistan: false,
        pakistan: false,
        india: false,
        bangladesh: false,
        sriLanka: false,
        nepal: false,
        bhutan: false,
        myanmar: false,
        thailand: false,
        laos: false,
        cambodia: false,
        vietnam: false,
        indonesia: false,
        philippines: false,
        brunei: false,
        eastTimor: false,
        papuaNewGuinea: false,
        fiji: false,
        solomonIslands: false,
        vanuatu: false,
        samoa: false,
        tonga: false,
        marshallIslands: false,
        micronesia: false,
        palau: false,
        nauru: false,
        tuvalu: false,
        kiribati: false
    });
    const [showMoreJobCountry, setShowMoreJobCountry] = useState(false);

    const [candidateLocation, setCandidateLocation] = useState({
        india: false,
        bangladesh: false,
        nepal: false,
        sriLanka: false,
        pakistan: false,
        philippines: false,
        indonesia: false,
        myanmar: false,
        vietnam: false,
        cambodia: false,
        thailand: false,
        ethiopia: false,
        kenya: false,
        uganda: false,
        tanzania: false,
        rwanda: false,
        ghana: false,
        nigeria: false,
        sierraLeone: false,
        burundi: false
    });
    const [jobType, setJobType] = useState({
        fullTime: false,
        partTime: false,
        liveIn: false,
        liveOut: false,
        temporary: false,
        permanent: false,
        internship: false,
        contractual: false,
        freelance: false,
        volunteer: false,
        fresher: false
    });
    const [contractStatus, setContractStatus] = useState({
        permanent: false,
        temporary: false,
        contract: false
    });
    const [postedBy, setPostedBy] = useState({
        agency: false,
        directEmployer: false
    });
    const [language, setLanguage] = useState({
        english: false,
        mandarin: false,
        arabic: false,
        hindi: false,
        tagalog: false,
        cantonese: false,
        malay: false,
        tamil: false
    });
    const [mainSkills, setMainSkills] = useState({
        childcare: false,
        elderlyCare: false,
        cooking: false,
        cleaning: false,
        laundry: false,
        ironing: false,
        petCare: false,
        gardening: false
    });
    const [startDate, setStartDate] = useState('');
    const [showMoreLocations, setShowMoreLocations] = useState(false);
    const [showNursingLicenseFilter, setShowNursingLicenseFilter] = useState(true);
    const [showApplyCountryFilter, setShowApplyCountryFilter] = useState(true);
    const [showCurrentLocationFilter, setShowCurrentLocationFilter] = useState(false);
    const [showNationalityFilter, setShowNationalityFilter] = useState(false);
    const [showExperienceFilter, setShowExperienceFilter] = useState(false);
    const [showSalaryTypeFilter, setShowSalaryTypeFilter] = useState(false);
    const [showGenderFilter, setShowGenderFilter] = useState(false);
    const [showAvailabilityFilter, setShowAvailabilityFilter] = useState(false);
    const [showAccommodationFilter, setShowAccommodationFilter] = useState(false);
    const [showLanguageFilter, setShowLanguageFilter] = useState(false);
    const [showProfileTypeFilter, setShowProfileTypeFilter] = useState(false);
    const [showMoreLicenses, setShowMoreLicenses] = useState(false);
    const [showMoreApplyCountries, setShowMoreApplyCountries] = useState(false);
    const [showMoreCurrentLocations, setShowMoreCurrentLocations] = useState(false);
    const [showMoreNationalities, setShowMoreNationalities] = useState(false);
    const [showMoreLanguagesFilter, setShowMoreLanguagesFilter] = useState(false);
    const [showMoreJobPositionOptions, setShowMoreJobPositionOptions] = useState(false);
    const [selectedJobPositions, setSelectedJobPositions] = useState([]);
    const [selectedNursingLicenses, setSelectedNursingLicenses] = useState([]);
    const [selectedApplyCountries, setSelectedApplyCountries] = useState([]);
    const [selectedCurrentLocations, setSelectedCurrentLocations] = useState([]);
    const [selectedNationalities, setSelectedNationalities] = useState([]);
    const [selectedExperienceRanges, setSelectedExperienceRanges] = useState([]);
    const [selectedSalaryTypes, setSelectedSalaryTypes] = useState([]);
    const [selectedGenders, setSelectedGenders] = useState([]);
    const [selectedAvailability, setSelectedAvailability] = useState([]);
    const [selectedAccommodation, setSelectedAccommodation] = useState([]);
    const [selectedLanguages, setSelectedLanguages] = useState([]);
    const [selectedProfileTypes, setSelectedProfileTypes] = useState([]);
    const [verifiedOnly, setVerifiedOnly] = useState(false);

    const resetAllFilters = () => {
        setJobPosition({
            maid: false,
            driver: false,
            cook: false,
            nanny: false,
            nurse: false,
            houseboy: false,
            tailor: false,
            teacher: false,
            trainer: false,
            gardener: false,
            butler: false,
            housekeeper: false,
            laundryWorker: false,
            personalAssistant: false,
            caregiver: false,
            elderCareCompanion: false,
            petSitter: false,
            houseManager: false,
            cleaner: false,
            maintenanceWorker: false,
            babySitter: false,
            tutor: false,
            chauffeur: false,
            housemaid: false,
            kitchenStaff: false,
            diningRoomAttendant: false,
            personalChef: false,
            eventCoordinator: false,
            householdAdministrator: false,
            domesticAssistant: false
        });

        // Inside resetAllFilters function, add this before the closing brace:
        setJobCountry({
            qatar: false,
            uae: false,
            saudiArabia: false,
            kuwait: false,
            bahrain: false,
            oman: false,
            usa: false,
            canada: false,
            uk: false,
            australia: false,
            germany: false,
            france: false,
            italy: false,
            spain: false,
            netherlands: false,
            belgium: false,
            switzerland: false,
            sweden: false,
            norway: false,
            denmark: false,
            finland: false,
            japan: false,
            southKorea: false,
            singapore: false,
            malaysia: false,
            china: false,
            hongKong: false,
            newZealand: false,
            southAfrica: false,
            brazil: false,
            mexico: false,
            argentina: false,
            chile: false,
            colombia: false,
            peru: false,
            egypt: false,
            morocco: false,
            algeria: false,
            tunisia: false,
            jordan: false,
            lebanon: false,
            iraq: false,
            iran: false,
            turkey: false,
            cyprus: false,
            malta: false,
            greece: false,
            portugal: false,
            austria: false,
            hungary: false,
            poland: false,
            czechRepublic: false,
            slovakia: false,
            slovenia: false,
            croatia: false,
            romania: false,
            bulgaria: false,
            serbia: false,
            montenegro: false,
            albania: false,
            northMacedonia: false,
            bosniaHerzegovina: false,
            kosovo: false,
            estonia: false,
            latvia: false,
            lithuania: false,
            belarus: false,
            ukraine: false,
            moldova: false,
            georgia: false,
            armenia: false,
            azerbaijan: false,
            kazakhstan: false,
            uzbekistan: false,
            turkmenistan: false,
            kyrgyzstan: false,
            tajikistan: false,
            afghanistan: false,
            pakistan: false,
            india: false,
            bangladesh: false,
            sriLanka: false,
            nepal: false,
            bhutan: false,
            myanmar: false,
            thailand: false,
            laos: false,
            cambodia: false,
            vietnam: false,
            indonesia: false,
            philippines: false,
            brunei: false,
            eastTimor: false,
            papuaNewGuinea: false,
            fiji: false,
            solomonIslands: false,
            vanuatu: false,
            samoa: false,
            tonga: false,
            marshallIslands: false,
            micronesia: false,
            palau: false,
            nauru: false,
            tuvalu: false,
            kiribati: false
        });
        setCandidateLocation({
            india: false,
            bangladesh: false,
            nepal: false,
            sriLanka: false,
            pakistan: false,
            philippines: false,
            indonesia: false,
            myanmar: false,
            vietnam: false,
            cambodia: false,
            thailand: false,
            ethiopia: false,
            kenya: false,
            uganda: false,
            tanzania: false,
            rwanda: false,
            ghana: false,
            nigeria: false,
            sierraLeone: false,
            burundi: false
        });

        setJobType({
            fullTime: false,
            partTime: false,
            liveIn: false,
            liveOut: false,
            temporary: false,
            permanent: false,
            internship: false,
            contractual: false,
            freelance: false,
            volunteer: false,
            fresher: false
        });
        setContractStatus({
            permanent: false,
            temporary: false,
            contract: false
        });
        setPostedBy({
            agency: false,
            directEmployer: false
        });
        setLanguage({
            english: false,
            mandarin: false,
            arabic: false,
            hindi: false,
            tagalog: false,
            cantonese: false,
            malay: false,
            tamil: false
        });
        setMainSkills({
            childcare: false,
            elderlyCare: false,
            cooking: false,
            cleaning: false,
            laundry: false,
            ironing: false,
            petCare: false,
            gardening: false
        });
        setStartDate('');
        setSelectedJobPositions([]);
        setSelectedNursingLicenses([]);
        setSelectedApplyCountries([]);
        setSelectedCurrentLocations([]);
        setSelectedNationalities([]);
        setSelectedExperienceRanges([]);
        setSelectedSalaryTypes([]);
        setSelectedGenders([]);
        setSelectedAvailability([]);
        setSelectedAccommodation([]);
        setSelectedLanguages([]);
        setSelectedProfileTypes([]);
        setVerifiedOnly(false);
    };

    const handleJobPositionChange = (e) => {
        const { name, checked } = e.target;
        setJobPosition(prev => ({
            ...prev,
            [name]: checked
        }));
    };

    const handleJobCountryChange = (e) => {
        const { name, checked } = e.target;
        setJobCountry(prev => ({
            ...prev,
            [name]: checked
        }));
    };

    const handleCandidateLocationChange = (e) => {
        const { name, checked } = e.target;
        setCandidateLocation(prev => ({
            ...prev,
            [name]: checked
        }));
    };

    const handleJobTypeChange = (e) => {
        const { name, checked } = e.target;
        setJobType(prev => ({
            ...prev,
            [name]: checked
        }));
    };

    const handleContractStatusChange = (e) => {
        const { name, checked } = e.target;
        setContractStatus(prev => ({
            ...prev,
            [name]: checked
        }));
    };

    const handlePostedByChange = (e) => {
        const { name, checked } = e.target;
        setPostedBy(prev => ({
            ...prev,
            [name]: checked
        }));
    };

    const handleLanguageChange = (e) => {
        const { name, checked } = e.target;
        setLanguage(prev => ({
            ...prev,
            [name]: checked
        }));
    };

    const handleMainSkillsChange = (e) => {
        const { name, checked } = e.target;
        setMainSkills(prev => ({
            ...prev,
            [name]: checked
        }));
    };

    const handleStartDateChange = (e) => {
        setStartDate(e.target.value);
    };

    const applySearchTerm = async (rawSearchValue) => {
        const nextSearchTerm = rawSearchValue.trim().toLowerCase();

        if (nextSearchTerm && hasMore) {
            try {
                setLoadingMore(true);
                await loadRemainingHealthcarePages();
            } catch (err) {
                setError(err.message);
            } finally {
                setLoadingMore(false);
            }
        }

        setSearchTerm(nextSearchTerm);
    };

    const handleSearchSubmit = async (e) => {
        e.preventDefault();
        await applySearchTerm(searchInput);
    };

    const handleSendAlertClick = () => {
        triggerSendAlertAction({
            navigate,
            user,
            pageKey: healthcarePageKey,
            jobPosition: healthcarePageLabel
        });
    };

    useEffect(() => {
        if (autoSearchTimeoutRef.current) {
            clearTimeout(autoSearchTimeoutRef.current);
        }

        autoSearchTimeoutRef.current = setTimeout(async () => {
            if (isAutoSearchingRef.current) return;

            const normalizedSearchInput = searchInput.trim().toLowerCase();
            if (normalizedSearchInput === searchTerm) return;

            isAutoSearchingRef.current = true;
            try {
                await applySearchTerm(searchInput);
            } finally {
                isAutoSearchingRef.current = false;
            }
        }, 350);

        return () => {
            if (autoSearchTimeoutRef.current) {
                clearTimeout(autoSearchTimeoutRef.current);
            }
        };
    }, [searchInput, searchTerm, hasMore, page, candidates]);

    const toggleMoreLocations = () => {
        setShowMoreLocations(!showMoreLocations);
    };

    const handleViewClick = (userId) => {
        navigate(`/allcandidatesdetails/${userId}`);
    };

    const formatDate = (dateString) => {
        if (!dateString) return 'N/A';

        try {
            const date = new Date(dateString.includes('T') ? dateString : dateString + 'T00:00:00');
            return date.toLocaleDateString('en-GB', {
                day: '2-digit',
                month: '2-digit',
                year: 'numeric'
            });
        } catch (e) {
            console.error('Error formatting date:', e);
            return 'N/A';
        }
    };

    const safeParseArray = (field) => {
        if (Array.isArray(field)) return field;
        if (typeof field === 'string') {
            try {
                const parsed = JSON.parse(field.replace(/\\"/g, '"'));
                return Array.isArray(parsed) ? parsed : [];
            } catch {
                return [];
            }
        }
        return [];
    };

    const normalizeText = (value) => (value || '').toString().replace(/\s+/g, ' ').trim();

    const toggleSelection = (value, setter) => {
        setter((prev) =>
            prev.includes(value) ? prev.filter((item) => item !== value) : [...prev, value]
        );
    };

    const getCandidateJobPositions = (candidate) => {
        const parsedPositions = safeParseArray(candidate.job_position)
            .map((position) => normalizeText(position))
            .filter(Boolean);

        if (parsedPositions.length > 0) {
            return parsedPositions;
        }

        const rawPosition = normalizeText(candidate.job_position);
        return rawPosition ? [rawPosition] : [];
    };

    const isDoctorPosition = (position) => {
        const normalizedPosition = normalizeText(position).toLowerCase();
        if (!normalizedPosition) return false;

        const doctorKeywords = [
            'doctor',
            'physician',
            'medical officer',
            'internal medicine',
            'pediatrician',
            'gynecologist',
            'surgeon',
            'cardiologist',
            'dermatologist',
            'neurologist',
            'psychiatrist',
            'gastroenterologist',
            'pulmonologist',
            'radiologist',
            'pathologist',
            'anesthesiologist',
            'icu specialist',
            'emergency medicine',
            'dentist',
            'orthodontist',
            'oral surgeon',
            'prosthodontist',
            'urologist',
            'consultant',
            'resident'
        ];

        return doctorKeywords.some((keyword) => normalizedPosition.includes(keyword));
    };

    const getCandidateLanguages = (candidate) => {
        const parsedLanguages = safeParseArray(candidate.language);

        if (!parsedLanguages.length) {
            return [];
        }

        return parsedLanguages
            .map((language) => {
                if (typeof language === 'string') return normalizeText(language);
                if (language && typeof language === 'object') return normalizeText(language.language);
                return '';
            })
            .filter(Boolean);
    };

    const getCandidateLicenses = (candidate) => {
        const rawSources = isDoctorPage
            ? [
                candidate.dtr_country_doctor_license,
                candidate.nursing_license_countries,
                candidate.nursing_license_country
            ]
            : [candidate.nursing_license_countries, candidate.nursing_license_country];
        let licenses = [];

        rawSources.forEach((raw) => {
            try {
                if (Array.isArray(raw)) {
                    licenses = [...licenses, ...raw];
                } else if (typeof raw === 'string' && raw.trim()) {
                    const parsed = JSON.parse(raw);
                    licenses = [...licenses, ...(Array.isArray(parsed) ? parsed : [parsed])];
                } else if (raw) {
                    licenses = [...licenses, raw];
                }
            } catch (e) {
                if (typeof raw === 'string' && raw.trim()) {
                    licenses = [...licenses, raw];
                }
            }
        });

        const cleanedLicenses = licenses
            .map((license) => {
                if (license && typeof license === 'object') {
                    return normalizeText(license.country_name || license.country || license.license_country);
                }
                return normalizeText(license);
            })
            .filter(
                (license) =>
                    license &&
                    license !== "I Don't have License" &&
                    license !== 'Not Licensed' &&
                    license !== "I don't have driving license"
            );

        const otherLicense = normalizeText(candidate.other_nursing_license_country);
        if (
            otherLicense &&
            otherLicense !== "I Don't have License" &&
            otherLicense !== 'Not Licensed' &&
            otherLicense !== "I don't have driving license"
        ) {
            cleanedLicenses.push(otherLicense);
        }

        const uniqueLicenses = [...new Set(cleanedLicenses)];
        return uniqueLicenses.length > 0 ? uniqueLicenses : ['Not Licensed'];
    };

    const getCandidateApplyCountry = (candidate) =>
        normalizeText((candidate.country_apply_for_job || '').replace(/^Jobs in\s+/i, ''));

    const getCandidateCurrentLocation = (candidate) => normalizeText(candidate.current_country);

    const getCandidateNationality = (candidate) => normalizeText(candidate.nationality);

    const getCandidateAccommodation = (candidate) => {
        const accommodation = normalizeText(candidate.accommodation_preference);
        if (!accommodation || accommodation.toLowerCase() === 'not specified') {
            return 'Live in/Live out';
        }
        return accommodation;
    };

    const isHealthcareCandidate = (candidate) => {
        if (!candidate) return false;

        const jobPositions = getCandidateJobPositions(candidate);
        return jobPositions.some((position) => {
            const normalizedPosition = position.toLowerCase();
            if (isDoctorPage) {
                return isDoctorPosition(normalizedPosition);
            }
            return normalizedPosition.includes('nurse') || normalizedPosition.includes('midwife');
        });
    };

    const normalizeCandidatesResponse = (result) => {
        if (!result) return { data: [], hasMore: false };
        if (Array.isArray(result)) return { data: result, hasMore: false };
        if (Array.isArray(result.data)) return { data: result.data, hasMore: Boolean(result.hasMore) };
        if (Array.isArray(result.candidates)) return { data: result.candidates, hasMore: Boolean(result.hasMore) };
        if (Array.isArray(result.users)) return { data: result.users, hasMore: Boolean(result.hasMore) };
        return { data: [], hasMore: false };
    };

    const prepareHealthcareCandidates = (items) => {
        const uniqueCandidates = new Map();

        items
            .filter(isHealthcareCandidate)
            .map((candidate) => ({
                ...candidate,
                job_position: safeParseArray(candidate.job_position),
                language: safeParseArray(candidate.language),
                main_skills: safeParseArray(candidate.main_skills),
                preferred_countries: safeParseArray(candidate.preferred_countries),
                work_experience: safeParseArray(candidate.work_experience)
            }))
            .forEach((candidate) => {
                const candidateKey =
                    candidate.id ||
                    candidate.user_id ||
                    candidate.job_seeker_id ||
                    `${candidate.email || ''}-${candidate.phone_number || ''}`;

                if (!uniqueCandidates.has(candidateKey)) {
                    uniqueCandidates.set(
                        candidateKey,
                        candidate.profile_photo
                            ? { ...candidate, profile_photo: `${BaseUrl}${candidate.profile_photo}` }
                            : candidate
                    );
                }
            });

        return Array.from(uniqueCandidates.values());
    };

    const fetchHealthcareCandidatesPage = async (pageToLoad) => {
        const segments = isDoctorPage ? ['doctor'] : ['nurse', 'domestic-staff'];
        const responses = await Promise.all(
            segments.map(async (segment) => {
                const response = await fetch(
                    `${BaseUrl}/api/job-seeker/combine/all?paginated=1&segment=${segment}&page=${pageToLoad}&limit=${PAGE_SIZE}`
                );
                if (!response.ok) {
                    throw new Error('Failed to fetch candidates');
                }
                const result = await response.json();
                return normalizeCandidatesResponse(result);
            })
        );

        return {
            data: prepareHealthcareCandidates(responses.flatMap((response) => response.data)),
            hasMore: responses.some((response) => response.hasMore)
        };
    };

    const loadRemainingHealthcarePages = async () => {
        let nextPage = page;
        let nextHasMore = hasMore;
        let loadedCandidates = [...candidates];

        while (nextHasMore) {
            const nextResult = await fetchHealthcareCandidatesPage(nextPage + 1);
            nextPage += 1;
            nextHasMore = nextResult.hasMore;
            loadedCandidates = mergeUniqueCandidates(loadedCandidates, nextResult.data);
        }

        setCandidates(loadedCandidates);
        setPage(nextPage);
        setHasMore(nextHasMore);
    };

    const getCandidateSalaryType = (candidate) => {
        const storedType = normalizeText(candidate.salary_type);
        if (storedType) return storedType;

        const localAmount = parseFloat(candidate.expected_monthly_salary || 0);
        const usdAmount = parseFloat(candidate.expected_monthly_salary_usd || 0);
        const salaryText = normalizeText(candidate.expected_monthly_salary);

        if (salaryText.includes('–') || salaryText.includes('-')) return 'Salary Range';
        if (salaryText.includes('+')) return 'Salary Range';
        if (localAmount > 0 || usdAmount > 0) return 'Fix salary';
        return 'Negotiable';
    };

    const getCandidateAvailabilityKey = (candidate) => {
        const rawStartDate = normalizeText(candidate.preferred_start_date);

        if (!rawStartDate || rawStartDate.toLowerCase().includes('immediate')) {
            return 'Immediate';
        }

        const parsedDate = new Date(rawStartDate);
        if (Number.isNaN(parsedDate.getTime())) {
            return 'Other';
        }

        const now = new Date();
        now.setHours(0, 0, 0, 0);
        parsedDate.setHours(0, 0, 0, 0);

        const diffInDays = Math.ceil((parsedDate - now) / (1000 * 60 * 60 * 24));

        if (diffInDays <= 0) return 'Immediate';
        if (diffInDays <= 15) return 'Within 15 days';
        if (diffInDays <= 30) return 'Within 30 days';
        return 'Other';
    };

    const matchesExperienceRange = (experienceText, range) => {
        const normalizedExperience = normalizeText(experienceText).toLowerCase();

        if (range === 'Fresher') {
            return normalizedExperience.includes('fresher') || normalizedExperience.includes('0');
        }

        const experienceMatches = normalizedExperience.match(/\d+(\.\d+)?/g);
        const experienceValues = experienceMatches?.length
            ? experienceMatches.map(Number)
            : [];

        if (experienceValues.length === 0) {
            return false;
        }

        if (range === '1 Year') return experienceValues.some((value) => value >= 1 && value < 2);
        if (range === '2 Years') return experienceValues.some((value) => value >= 2 && value < 3);
        if (range === '3 Years') return experienceValues.some((value) => value >= 3 && value < 4);
        if (range === '4-5 Years') return experienceValues.some((value) => value >= 4 && value < 6);
        if (range === '6+ Years') return experienceValues.some((value) => value >= 6);

        return false;
    };

    const buildUniqueOptions = (values) =>
        [...new Set(values.map((value) => normalizeText(value)).filter(Boolean))].sort((a, b) =>
            a.localeCompare(b)
        );

    const nurseJobPositionOptions = buildUniqueOptions(candidates.flatMap(getCandidateJobPositions));
    const nursingLicenseOptions = buildUniqueOptions(candidates.flatMap(getCandidateLicenses));
    const applyCountryOptions = buildUniqueOptions(candidates.map(getCandidateApplyCountry));
    const currentLocationOptions = buildUniqueOptions(candidates.map(getCandidateCurrentLocation));
    const nationalityOptions = buildUniqueOptions(candidates.map(getCandidateNationality));
    const languageOptions = buildUniqueOptions(candidates.flatMap(getCandidateLanguages));

    const experienceOptions = ['Fresher', '1 Year', '2 Years', '3 Years', '4-5 Years', '6+ Years'];
    const salaryTypeOptions = ['Fix salary', 'Salary Range', 'Negotiable'];
    const genderOptions = ['Male', 'Female'];
    const availabilityOptions = ['Immediate', 'Within 15 days', 'Within 30 days', 'Other'];
    const accommodationOptions = ['Live In', 'Live Out', 'Live in/Live out'];
    const profileTypeOptions = ['Agency', 'Direct'];

    const renderFilterSection = ({
        title,
        isOpen,
        onToggle,
        options,
        selectedValues,
        onOptionToggle,
        showMore = false,
        setShowMore = null,
        initialVisible = 5,
        emptyText = 'No options available'
    }) => {
        const visibleOptions = showMore ? options : options.slice(0, initialVisible);

        return (
            <div className="mb-4 viewjobposting-filter-section">
                <div
                    className="d-flex flex-row justify-content-between align-items-center cursor-pointer mb-2"
                    onClick={onToggle}
                >
                    <strong>{title}</strong>
                    <i className={`bi ${isOpen ? 'bi-chevron-down' : 'bi-chevron-right'}`}></i>
                </div>
                {isOpen && (
                    <div className="d-flex flex-column gap-2">
                        {visibleOptions.length === 0 && (
                            <small className="text-muted">{emptyText}</small>
                        )}
                        {visibleOptions.map((option) => {
                            const id = `${title}-${option}`.replace(/[^a-zA-Z0-9]/g, '-').toLowerCase();
                            return (
                                <div key={option} className="form-check">
                                    <input
                                        className="form-check-input-allcandidates"
                                        type="checkbox"
                                        id={id}
                                        checked={selectedValues.includes(option)}
                                        onChange={() => onOptionToggle(option)}
                                    />
                                    <label className="form-check-label" htmlFor={id}>
                                        {option}
                                    </label>
                                </div>
                            );
                        })}
                        {setShowMore && options.length > initialVisible && (
                            <button
                                type="button"
                                className="btn btn-link p-0 text-decoration-none viewjobposting-text-primary text-start"
                                onClick={(event) => {
                                    event.stopPropagation();
                                    setShowMore((prev) => !prev);
                                }}
                            >
                                {showMore ? 'Show Less' : `Show ${options.length - initialVisible} More`}
                            </button>
                        )}
                    </div>
                )}
            </div>
        );
    };

    const handleContactAction = (actionType, candidate = null) => {
        if (!user.id) {
            Swal.fire({
                title: '<div class="swal-custom-title">Please Register or Login</div>',
                text: `You must be registered and logged in to contact this candidate via ${actionType}`,
                icon: 'info',
                showCancelButton: true,
                showDenyButton: true,
                confirmButtonText: 'Register',
                cancelButtonText: 'Login',
                denyButtonText: '<i class="bi bi-whatsapp"></i> Continue with WhatsApp',
                customClass: {
                    popup: 'registration-popup',
                    confirmButton: 'swal-register-btn',
                    cancelButton: 'swal-login-btn',
                    denyButton: 'swal-whatsapp-btn',
                    actions: 'swal-actions-column'
                },
                buttonsStyling: false,
                showCloseButton: true,
                footer: '<div class="swal-footer-text">Registration helps prevent fake profiles</div>'
            }).then((result) => {
                if (result.isConfirmed) {
                    navigate('/register', {
                        state: { defaultTab: 'employer' }
                    });
                } else if (result.dismiss === Swal.DismissReason.cancel) {
                    navigate('/login');
                } else if (result.isDenied) {
                    const message = encodeURIComponent('Hello, I want to register on GulfWorker.\nPlease guide me with the registration process');
                    window.open(`https://wa.me/97477651422?text=${message}`, '_blank');
                }
            });
        } else {
            // Handle the action for logged-in users
            switch (actionType) {
                case 'videoCall':
                    if (!user || user.role !== 'agency') {
                        Swal.fire('Access Denied', 'Video Call feature is only available to Agencies.', 'error');
                    } else if (user.plan_name === 'Free') {
                        Swal.fire({
                            icon: 'error',
                            title: 'Upgrade Required',
                            text: 'Video Call feature is available for exclusive plans. Please upgrade.',
                            confirmButtonText: 'Upgrade Now'
                        }).then((result) => {
                             // Assuming navigate is in scope, else standard href
                             if (result.isConfirmed) window.location.href = '/subscription';
                        });
                    } else {
                        window.dispatchEvent(new CustomEvent('initiate-video-call', { detail: { candidateId: candidate?.user_id || candidate?.id, candidateName: candidate?.first_name } }));
                    }
                    break;
                case 'call':
                    console.log('Calling candidate...');
                    // Add actual call functionality here
                    break;
                case 'whatsapp':
                    console.log('Opening WhatsApp...');
                    // Add actual WhatsApp functionality here
                    if (candidate && candidate.phone_number) {
                        const whatsappUrl = `https://wa.me/${candidate.phone_number}`;
                        window.open(whatsappUrl, '_blank');
                    }
                    break;
                case 'message':
                    console.log('Opening message...');
                    // Add actual message functionality here
                    break;
                case 'wishlist':
                    console.log('Adding to wishlist...');
                    // Add actual wishlist functionality here
                    break;
                case 'share':
                    console.log('Sharing candidate...');
                    // Add actual share functionality here
                    break;
                case 'report':
                    console.log('Reporting candidate...');
                    // Add actual report functionality here
                    break;
                default:
                    console.log(`Action: ${actionType}`);
            }
        }
    };
    const closeRegisterPopup = () => {
        setShowRegisterPopup(false);
    };

    const closeLoginPopup = () => {
        setShowLoginPopup(false);
    };

    const handleLoginSuccess = () => {
        closeLoginPopup();
    };

    useEffect(() => {
        const checkScreenSize = () => {
            const mobile = window.innerWidth < 768;
            setIsMobile(mobile);

            // If desktop, open all filters
            if (!mobile) {
                setShowLocation(true);
                setShowMoreJobPosition(true);
                setShowMoreJobType(true);
                setShowContractStatus(true);
                setShowPostedBy(true);
                setShowMoreLanguage(true);
                setShowMoreMainSkills(true);
                setShowStartDate(true);
                setShowFiltersMobile(true);
            } else {
                // If mobile, close all filters by default
                setShowLocation(false);
                setShowMoreJobPosition(false);
                setShowMoreJobType(false);
                setShowContractStatus(false);
                setShowPostedBy(false);
                setShowMoreLanguage(false);
                setShowMoreMainSkills(false);
                setShowStartDate(false);
                setShowFiltersMobile(false);
            }
        };

        checkScreenSize();
        window.addEventListener('resize', checkScreenSize);
        return () => window.removeEventListener('resize', checkScreenSize);
    }, []);

    useEffect(() => {
        const fetchCandidates = async () => {
            try {
                let { data: updatedData, hasMore: nextHasMore } = await fetchHealthcareCandidatesPage(1);
                let currentPage = 1;

                // Keep fetching until we have at least 9 candidates
                while (updatedData.length < 9 && nextHasMore) {
                    currentPage++;
                    const nextResult = await fetchHealthcareCandidatesPage(currentPage);
                    updatedData = mergeUniqueCandidates(updatedData, nextResult.data);
                    nextHasMore = nextResult.hasMore;
                }

                setCandidates(updatedData);
                setFilteredCandidates(updatedData);
                setPage(currentPage);
                setHasMore(nextHasMore);
            } catch (err) {
                setError(err.message);
            } finally {
                setLoading(false);
            }
        };

        fetchCandidates();
    }, [healthcareType]);

    const handleLoadMore = async () => {
        const nextVisible = visibleCount + 9;
        setVisibleCount(nextVisible);

        // If we need more data from API and there's more to fetch
        if (nextVisible >= filteredCandidates.length && hasMore && !loadingMore) {
            try {
                setLoadingMore(true);
                let currentCandidates = [...candidates];
                let currentHasMore = hasMore;
                let currentPage = page;

                // Keep fetching until we have enough candidates or run out of data
                while (currentHasMore && currentCandidates.filter(isHealthcareCandidate).length < nextVisible) {
                    const nextPageNumber = currentPage + 1;
                    const nextResult = await fetchHealthcareCandidatesPage(nextPageNumber);
                    
                    if (nextResult.data.length === 0 && !nextResult.hasMore) break;
                    
                    currentCandidates = mergeUniqueCandidates(currentCandidates, nextResult.data);
                    currentHasMore = nextResult.hasMore;
                    currentPage = nextPageNumber;
                    
                    if (nextResult.data.length === 0) break; // Avoid infinite loops
                }

                setCandidates(currentCandidates);
                setPage(currentPage);
                setHasMore(currentHasMore);
            } catch (err) {
                setError(err.message);
            } finally {
                setLoadingMore(false);
            }
        }
    };

    useEffect(() => {
        let result = [...candidates];

        if (selectedJobPositions.length > 0) {
            result = result.filter((candidate) =>
                getCandidateJobPositions(candidate).some((position) =>
                    selectedJobPositions.includes(position)
                )
            );
        }

        if (selectedNursingLicenses.length > 0) {
            result = result.filter((candidate) =>
                getCandidateLicenses(candidate).some((license) =>
                    selectedNursingLicenses.includes(license)
                )
            );
        }

        if (selectedApplyCountries.length > 0) {
            result = result.filter((candidate) =>
                selectedApplyCountries.includes(getCandidateApplyCountry(candidate))
            );
        }

        if (selectedCurrentLocations.length > 0) {
            result = result.filter((candidate) =>
                selectedCurrentLocations.includes(getCandidateCurrentLocation(candidate))
            );
        }

        if (selectedNationalities.length > 0) {
            result = result.filter((candidate) =>
                selectedNationalities.includes(getCandidateNationality(candidate))
            );
        }

        if (selectedExperienceRanges.length > 0) {
            result = result.filter((candidate) =>
                selectedExperienceRanges.some((range) =>
                    matchesExperienceRange(candidate.total_work_experience, range)
                )
            );
        }

        if (selectedSalaryTypes.length > 0) {
            result = result.filter((candidate) =>
                selectedSalaryTypes.includes(getCandidateSalaryType(candidate))
            );
        }

        if (selectedGenders.length > 0) {
            result = result.filter((candidate) =>
                selectedGenders.includes(normalizeText(candidate.gender))
            );
        }

        if (selectedAvailability.length > 0) {
            result = result.filter((candidate) =>
                selectedAvailability.includes(getCandidateAvailabilityKey(candidate))
            );
        }

        if (selectedAccommodation.length > 0) {
            result = result.filter((candidate) =>
                selectedAccommodation.includes(getCandidateAccommodation(candidate))
            );
        }

        if (selectedLanguages.length > 0) {
            result = result.filter((candidate) =>
                getCandidateLanguages(candidate).some((language) =>
                    selectedLanguages.includes(language)
                )
            );
        }

        if (selectedProfileTypes.length > 0) {
            result = result.filter((candidate) => {
                const source = normalizeText(candidate.source).toLowerCase();
                return (
                    (selectedProfileTypes.includes('Agency') && source.includes('agency')) ||
                    (selectedProfileTypes.includes('Direct') && source.includes('direct'))
                );
            });
        }

        if (verifiedOnly) {
            result = result.filter(
                (candidate) => candidate.verification_status?.toLowerCase() === 'verified'
            );
        }

        if (searchTerm) {
            const term = searchTerm.toLowerCase();
            result = result.filter(candidate => {
                const fullName = `${candidate.first_name || ''} ${candidate.last_name || ''}`.toLowerCase();
                const nationality = getCandidateNationality(candidate).toLowerCase();
                const currentCountry = getCandidateCurrentLocation(candidate).toLowerCase();
                const applyCountry = getCandidateApplyCountry(candidate).toLowerCase();
                const jobPositions = getCandidateJobPositions(candidate).join(' ').toLowerCase();
                const nursingLicenses = getCandidateLicenses(candidate).join(' ').toLowerCase();
                const languages = getCandidateLanguages(candidate).join(' ').toLowerCase();
                return (
                    fullName.includes(term) ||
                    nationality.includes(term) ||
                    currentCountry.includes(term) ||
                    applyCountry.includes(term) ||
                    jobPositions.includes(term) ||
                    nursingLicenses.includes(term) ||
                    languages.includes(term)
                );
            });
        }

        setFilteredCandidates(result);
    }, [
        candidates,
        selectedJobPositions,
        selectedNursingLicenses,
        selectedApplyCountries,
        selectedCurrentLocations,
        selectedNationalities,
        selectedExperienceRanges,
        selectedSalaryTypes,
        selectedGenders,
        selectedAvailability,
        selectedAccommodation,
        selectedLanguages,
        selectedProfileTypes,
        verifiedOnly,
        searchTerm
    ]);

    // Reset visible count only when user changes filters
    useEffect(() => {
        setVisibleCount(9);
    }, [selectedJobPositions, selectedNursingLicenses, selectedApplyCountries, selectedCurrentLocations, selectedNationalities, selectedExperienceRanges, selectedSalaryTypes, selectedGenders, selectedAvailability, selectedAccommodation, selectedLanguages, selectedProfileTypes, verifiedOnly, searchTerm]);

    if (loading) {
        return (
            <>
                <Navbar />
                <div className="text-center mt-5">Loading candidates...</div>
            </>
        );
    }

    if (error) {
        return (
            <>
                <Navbar />
                <div className="text-center mt-5 text-danger">Error: {error}</div>
            </>
        );
    }

    return (
        <>
            <Navbar />
            <Container fluid className="nurse-page px-2 py-3" style={{ marginTop: '80px' }}>
                <Row className="gx-2">
                    {/* Filter Section */}
                    {isMobile && (
                        <div className="mb-3">
                            <button
                                className="btn btn-primary w-100"
                                onClick={() => setShowFiltersMobile(!showFiltersMobile)}
                            >
                                <i className="bi bi-funnel me-2"></i>
                                {showFiltersMobile ? 'Hide Filters' : 'Show Filters'}
                            </button>
                        </div>
                    )}
                    <Col md={3} lg={2}>
                        {(showFiltersMobile || !isMobile) && (
                            <div className="viewjobposting-filters p-3 border rounded bg-light" style={{ marginTop: '20px' }}>
                                {/* Filter Header with Refresh Button */}
                                <div className="d-flex justify-content-between align-items-center mb-4">
                                    <h5 className="mb-0">Filters</h5>
                                    <button
                                        className="btn btn-sm btn-outline-secondary"
                                        onClick={resetAllFilters}
                                        title="Reset all filters"
                                    >
                                        <i className="bi bi-arrow-clockwise"></i> Reset
                                    </button>
                                </div>

                                {renderFilterSection({
                                    title: 'Job Position',
                                    isOpen: showMoreJobPosition,
                                    onToggle: () => setShowMoreJobPosition((prev) => !prev),
                                    options: nurseJobPositionOptions,
                                    selectedValues: selectedJobPositions,
                                    onOptionToggle: (value) => toggleSelection(value, setSelectedJobPositions),
                                    showMore: showMoreJobPositionOptions,
                                    setShowMore: setShowMoreJobPositionOptions,
                                    initialVisible: 6
                                })}

                                {renderFilterSection({
                                    title: healthcareLicenseLabel,
                                    isOpen: showNursingLicenseFilter,
                                    onToggle: () => setShowNursingLicenseFilter((prev) => !prev),
                                    options: nursingLicenseOptions,
                                    selectedValues: selectedNursingLicenses,
                                    onOptionToggle: (value) => toggleSelection(value, setSelectedNursingLicenses),
                                    showMore: true,
                                    initialVisible: nursingLicenseOptions.length || 1
                                })}

                                {renderFilterSection({
                                    title: 'Country To Apply For',
                                    isOpen: showApplyCountryFilter,
                                    onToggle: () => setShowApplyCountryFilter((prev) => !prev),
                                    options: applyCountryOptions,
                                    selectedValues: selectedApplyCountries,
                                    onOptionToggle: (value) => toggleSelection(value, setSelectedApplyCountries),
                                    showMore: showMoreApplyCountries,
                                    setShowMore: setShowMoreApplyCountries,
                                    initialVisible: 6
                                })}

                                {renderFilterSection({
                                    title: 'Current Location',
                                    isOpen: showCurrentLocationFilter,
                                    onToggle: () => setShowCurrentLocationFilter((prev) => !prev),
                                    options: currentLocationOptions,
                                    selectedValues: selectedCurrentLocations,
                                    onOptionToggle: (value) => toggleSelection(value, setSelectedCurrentLocations),
                                    showMore: showMoreCurrentLocations,
                                    setShowMore: setShowMoreCurrentLocations,
                                    initialVisible: 6
                                })}

                                {renderFilterSection({
                                    title: 'Candidate Nationality',
                                    isOpen: showNationalityFilter,
                                    onToggle: () => setShowNationalityFilter((prev) => !prev),
                                    options: nationalityOptions,
                                    selectedValues: selectedNationalities,
                                    onOptionToggle: (value) => toggleSelection(value, setSelectedNationalities),
                                    showMore: showMoreNationalities,
                                    setShowMore: setShowMoreNationalities,
                                    initialVisible: 6
                                })}

                                {renderFilterSection({
                                    title: 'Experience',
                                    isOpen: showExperienceFilter,
                                    onToggle: () => setShowExperienceFilter((prev) => !prev),
                                    options: experienceOptions,
                                    selectedValues: selectedExperienceRanges,
                                    onOptionToggle: (value) => toggleSelection(value, setSelectedExperienceRanges),
                                    initialVisible: 6
                                })}

                                {renderFilterSection({
                                    title: 'Salary Type',
                                    isOpen: showSalaryTypeFilter,
                                    onToggle: () => setShowSalaryTypeFilter((prev) => !prev),
                                    options: salaryTypeOptions,
                                    selectedValues: selectedSalaryTypes,
                                    onOptionToggle: (value) => toggleSelection(value, setSelectedSalaryTypes),
                                    initialVisible: 5
                                })}

                                {renderFilterSection({
                                    title: 'Gender',
                                    isOpen: showGenderFilter,
                                    onToggle: () => setShowGenderFilter((prev) => !prev),
                                    options: genderOptions,
                                    selectedValues: selectedGenders,
                                    onOptionToggle: (value) => toggleSelection(value, setSelectedGenders),
                                    initialVisible: 5
                                })}

                                {renderFilterSection({
                                    title: 'Availability',
                                    isOpen: showAvailabilityFilter,
                                    onToggle: () => setShowAvailabilityFilter((prev) => !prev),
                                    options: availabilityOptions,
                                    selectedValues: selectedAvailability,
                                    onOptionToggle: (value) => toggleSelection(value, setSelectedAvailability),
                                    initialVisible: 5
                                })}

                                {renderFilterSection({
                                    title: 'Accommodation',
                                    isOpen: showAccommodationFilter,
                                    onToggle: () => setShowAccommodationFilter((prev) => !prev),
                                    options: accommodationOptions,
                                    selectedValues: selectedAccommodation,
                                    onOptionToggle: (value) => toggleSelection(value, setSelectedAccommodation),
                                    initialVisible: 5
                                })}

                                {renderFilterSection({
                                    title: 'Language',
                                    isOpen: showLanguageFilter,
                                    onToggle: () => setShowLanguageFilter((prev) => !prev),
                                    options: languageOptions,
                                    selectedValues: selectedLanguages,
                                    onOptionToggle: (value) => toggleSelection(value, setSelectedLanguages),
                                    showMore: showMoreLanguagesFilter,
                                    setShowMore: setShowMoreLanguagesFilter,
                                    initialVisible: 6
                                })}

                                <div className="mb-4 viewjobposting-filter-section">
                                    <div
                                        className="d-flex flex-row justify-content-between align-items-center cursor-pointer mb-2"
                                        onClick={() => setShowProfileTypeFilter((prev) => !prev)}
                                    >
                                        <strong>Profile Type</strong>
                                        <i className={`bi ${showProfileTypeFilter ? 'bi-chevron-down' : 'bi-chevron-right'}`}></i>
                                    </div>
                                    {showProfileTypeFilter && (
                                        <div className="d-flex flex-column gap-2">
                                            {profileTypeOptions.map((option) => (
                                                <div key={option} className="form-check">
                                                    <input
                                                        className="form-check-input-allcandidates"
                                                        type="checkbox"
                                                        id={`profile-type-${option.toLowerCase()}`}
                                                        checked={selectedProfileTypes.includes(option)}
                                                        onChange={() => toggleSelection(option, setSelectedProfileTypes)}
                                                    />
                                                    <label className="form-check-label" htmlFor={`profile-type-${option.toLowerCase()}`}>
                                                        {option}
                                                    </label>
                                                </div>
                                            ))}
                                            <div className="form-check">
                                                <input
                                                    className="form-check-input-allcandidates"
                                                    type="checkbox"
                                                    id="profile-type-verified"
                                                    checked={verifiedOnly}
                                                    onChange={(event) => setVerifiedOnly(event.target.checked)}
                                                />
                                                <label className="form-check-label" htmlFor="profile-type-verified">
                                                    Verified only
                                                </label>
                                            </div>
                                        </div>
                                    )}
                                </div>

                                {false && (
                                <>

                                {/* Candidate Nationality Filter */}
                                {/* Candidate Nationality Filter */}
                                <div className="mb-4 viewjobposting-filter-section">
                                    <div
                                        className="d-flex flex-row justify-content-between align-items-center cursor-pointer mb-2"
                                        onClick={() => setShowLocation(!showLocation)}
                                    >
                                        <strong>Candidate Nationality</strong>
                                        <i className={`bi ${showLocation ? 'bi-chevron-down' : 'bi-chevron-right'}`}></i>
                                    </div>
                                    {showLocation && (
                                        <div className="d-flex flex-column gap-2">
                                            {[
                                                { id: 'india', name: 'India' },
                                                { id: 'bangladesh', name: 'Bangladesh' },
                                                { id: 'nepal', name: 'Nepal' },
                                                { id: 'sriLanka', name: 'Sri Lanka' },
                                                { id: 'pakistan', name: 'Pakistan' },
                                                { id: 'philippines', name: 'Philippines' },
                                                { id: 'indonesia', name: 'Indonesia' },
                                                { id: 'myanmar', name: 'Myanmar' },
                                                { id: 'vietnam', name: 'Vietnam' },
                                                { id: 'cambodia', name: 'Cambodia' },
                                                { id: 'thailand', name: 'Thailand' },
                                                { id: 'ethiopia', name: 'Ethiopia' },
                                                { id: 'kenya', name: 'Kenya' },
                                                { id: 'uganda', name: 'Uganda' },
                                                { id: 'tanzania', name: 'Tanzania' },
                                                { id: 'rwanda', name: 'Rwanda' },
                                                { id: 'ghana', name: 'Ghana' },
                                                { id: 'nigeria', name: 'Nigeria' },
                                                { id: 'sierraLeone', name: 'Sierra Leone' },
                                                { id: 'burundi', name: 'Burundi' }
                                            ].slice(0, showMoreLocations ? 32 : 5).map((location) => (
                                                <div key={location.id} className="form-check">
                                                    <input
                                                        className="form-check-input-allcandidates"
                                                        type="checkbox"
                                                        id={`location-${location.id}`}
                                                        checked={candidateLocation[location.id]}
                                                        onChange={(e) => handleCandidateLocationChange({
                                                            target: {
                                                                name: location.id,
                                                                checked: e.target.checked
                                                            }
                                                        })}
                                                    />
                                                    <label className="form-check-label" htmlFor={`location-${location.id}`}>
                                                        {location.name}
                                                    </label>
                                                </div>
                                            ))}
                                            {Object.keys(candidateLocation).length > 5 && (
                                                <button
                                                    className="btn btn-link p-0 text-decoration-none viewjobposting-text-primary" style={{ textAlign: 'left' }}
                                                    onClick={toggleMoreLocations}
                                                >
                                                    {showMoreLocations ? 'Show Less' : 'Show More'}
                                                </button>
                                            )}
                                        </div>
                                    )}
                                </div>

                                {/* Candidate Job Country Filter */}
                                <div className="mb-4 viewjobposting-filter-section">
                                    <div
                                        className="d-flex flex-row justify-content-between align-items-center cursor-pointer mb-2"
                                        onClick={() => setShowMoreJobCountry(!showMoreJobCountry)}
                                    >
                                        <strong>Candidate Job Country</strong>
                                        <i className={`bi ${showMoreJobCountry ? 'bi-chevron-down' : 'bi-chevron-right'}`}></i>
                                    </div>
                                    {showMoreJobCountry && (
                                        <div className="d-flex flex-column gap-2">
                                            {[
                                                // Gulf Countries
                                                { id: 'qatar', name: 'Qatar' },
                                                { id: 'uae', name: 'UAE/Dubai' },
                                                { id: 'saudiArabia', name: 'Saudi Arabia' },
                                                { id: 'kuwait', name: 'Kuwait' },
                                                { id: 'bahrain', name: 'Bahrain' },
                                                { id: 'oman', name: 'Oman' },

                                                // North America
                                                { id: 'usa', name: 'USA' },
                                                { id: 'canada', name: 'Canada' },

                                                // Europe
                                                { id: 'uk', name: 'United Kingdom' },
                                                { id: 'germany', name: 'Germany' },
                                                { id: 'france', name: 'France' },
                                                { id: 'italy', name: 'Italy' },
                                                { id: 'spain', name: 'Spain' },
                                                { id: 'netherlands', name: 'Netherlands' },
                                                { id: 'belgium', name: 'Belgium' },
                                                { id: 'switzerland', name: 'Switzerland' },
                                                { id: 'sweden', name: 'Sweden' },
                                                { id: 'norway', name: 'Norway' },
                                                { id: 'denmark', name: 'Denmark' },
                                                { id: 'finland', name: 'Finland' },
                                                { id: 'austria', name: 'Austria' },
                                                { id: 'hungary', name: 'Hungary' },
                                                { id: 'poland', name: 'Poland' },
                                                { id: 'czechRepublic', name: 'Czech Republic' },
                                                { id: 'slovakia', name: 'Slovakia' },
                                                { id: 'slovenia', name: 'Slovenia' },
                                                { id: 'croatia', name: 'Croatia' },
                                                { id: 'romania', name: 'Romania' },
                                                { id: 'bulgaria', name: 'Bulgaria' },
                                                { id: 'serbia', name: 'Serbia' },
                                                { id: 'montenegro', name: 'Montenegro' },
                                                { id: 'albania', name: 'Albania' },
                                                { id: 'northMacedonia', name: 'North Macedonia' },
                                                { id: 'bosniaHerzegovina', name: 'Bosnia & Herzegovina' },
                                                { id: 'kosovo', name: 'Kosovo' },
                                                { id: 'estonia', name: 'Estonia' },
                                                { id: 'latvia', name: 'Latvia' },
                                                { id: 'lithuania', name: 'Lithuania' },
                                                { id: 'belarus', name: 'Belarus' },
                                                { id: 'ukraine', name: 'Ukraine' },
                                                { id: 'moldova', name: 'Moldova' },
                                                { id: 'georgia', name: 'Georgia' },
                                                { id: 'armenia', name: 'Armenia' },
                                                { id: 'azerbaijan', name: 'Azerbaijan' },

                                                // Asia Pacific
                                                { id: 'japan', name: 'Japan' },
                                                { id: 'southKorea', name: 'South Korea' },
                                                { id: 'singapore', name: 'Singapore' },
                                                { id: 'malaysia', name: 'Malaysia' },
                                                { id: 'china', name: 'China' },
                                                { id: 'hongKong', name: 'Hong Kong' },
                                                { id: 'australia', name: 'Australia' },
                                                { id: 'newZealand', name: 'New Zealand' },

                                                // South Asia
                                                { id: 'india', name: 'India' },
                                                { id: 'pakistan', name: 'Pakistan' },
                                                { id: 'bangladesh', name: 'Bangladesh' },
                                                { id: 'sriLanka', name: 'Sri Lanka' },
                                                { id: 'nepal', name: 'Nepal' },
                                                { id: 'bhutan', name: 'Bhutan' },
                                                { id: 'myanmar', name: 'Myanmar' },
                                                { id: 'thailand', name: 'Thailand' },
                                                { id: 'laos', name: 'Laos' },
                                                { id: 'cambodia', name: 'Cambodia' },
                                                { id: 'vietnam', name: 'Vietnam' },
                                                { id: 'indonesia', name: 'Indonesia' },
                                                { id: 'philippines', name: 'Philippines' },
                                                { id: 'brunei', name: 'Brunei' },
                                                { id: 'eastTimor', name: 'East Timor' },

                                                // Middle East & Africa
                                                { id: 'turkey', name: 'Turkey' },
                                                { id: 'cyprus', name: 'Cyprus' },
                                                { id: 'malta', name: 'Malta' },
                                                { id: 'egypt', name: 'Egypt' },
                                                { id: 'morocco', name: 'Morocco' },
                                                { id: 'algeria', name: 'Algeria' },
                                                { id: 'tunisia', name: 'Tunisia' },
                                                { id: 'jordan', name: 'Jordan' },
                                                { id: 'lebanon', name: 'Lebanon' },
                                                { id: 'iraq', name: 'Iraq' },
                                                { id: 'iran', name: 'Iran' },
                                                { id: 'southAfrica', name: 'South Africa' },

                                                // Central Asia
                                                { id: 'kazakhstan', name: 'Kazakhstan' },
                                                { id: 'uzbekistan', name: 'Uzbekistan' },
                                                { id: 'turkmenistan', name: 'Turkmenistan' },
                                                { id: 'kyrgyzstan', name: 'Kyrgyzstan' },
                                                { id: 'tajikistan', name: 'Tajikistan' },
                                                { id: 'afghanistan', name: 'Afghanistan' },

                                                // Latin America
                                                { id: 'brazil', name: 'Brazil' },
                                                { id: 'mexico', name: 'Mexico' },
                                                { id: 'argentina', name: 'Argentina' },
                                                { id: 'chile', name: 'Chile' },
                                                { id: 'colombia', name: 'Colombia' },
                                                { id: 'peru', name: 'Peru' },

                                                // Pacific Islands
                                                { id: 'papuaNewGuinea', name: 'Papua New Guinea' },
                                                { id: 'fiji', name: 'Fiji' },
                                                { id: 'solomonIslands', name: 'Solomon Islands' },
                                                { id: 'vanuatu', name: 'Vanuatu' },
                                                { id: 'samoa', name: 'Samoa' },
                                                { id: 'tonga', name: 'Tonga' },
                                                { id: 'marshallIslands', name: 'Marshall Islands' },
                                                { id: 'micronesia', name: 'Micronesia' },
                                                { id: 'palau', name: 'Palau' },
                                                { id: 'nauru', name: 'Nauru' },
                                                { id: 'tuvalu', name: 'Tuvalu' },
                                                { id: 'kiribati', name: 'Kiribati' }
                                            ].map((country) => (
                                                <div key={country.id} className="form-check">
                                                    <input
                                                        className="form-check-input-allcandidates"
                                                        type="checkbox"
                                                        id={`jobCountry-${country.id}`}
                                                        checked={jobCountry[country.id]}
                                                        onChange={(e) => handleJobCountryChange({
                                                            target: {
                                                                name: country.id,
                                                                checked: e.target.checked
                                                            }
                                                        })}
                                                    />
                                                    <label className="form-check-label" htmlFor={`jobCountry-${country.id}`}>
                                                        {country.name}
                                                    </label>
                                                </div>
                                            ))}
                                            <button
                                                className="btn btn-link p-0 text-decoration-none viewjobposting-text-primary"
                                                style={{ textAlign: 'left' }}
                                                onClick={() => setShowMoreJobCountry(!showMoreJobCountry)}
                                            >
                                                {showMoreJobCountry ? 'Show Less' : 'Show More'}
                                            </button>
                                        </div>
                                    )}
                                </div>

                                {/* Job Position Filter */}
                                <div className="mb-4 viewjobposting-filter-section">
                                    <div
                                        className="d-flex flex-row justify-content-between align-items-center cursor-pointer mb-2"
                                        onClick={() => setShowMoreJobPosition(!showMoreJobPosition)}
                                    >
                                        <strong>Job Position</strong>
                                        <i className={`bi ${showMoreJobPosition ? 'bi-chevron-down' : 'bi-chevron-right'}`}></i>
                                    </div>
                                    {showMoreJobPosition && (
                                        <div className="d-flex flex-column gap-2">
                                            {[
                                                { id: 'maid', name: 'Maid' },
                                                { id: 'driver', name: 'Driver' },
                                                { id: 'cook', name: 'Cook' },
                                                { id: 'nanny', name: 'Nanny' },
                                                { id: 'nurse', name: 'Nurse' },
                                                { id: 'houseboy', name: 'Houseboy' },
                                                { id: 'tailor', name: 'Tailor' },
                                                { id: 'teacher', name: 'Teacher' },
                                                { id: 'trainer', name: 'Trainer' },
                                                { id: 'gardener', name: 'Gardener' },
                                                { id: 'butler', name: 'Butler' },
                                                { id: 'housekeeper', name: 'Housekeeper' },
                                                { id: 'laundryWorker', name: 'Laundry Worker' },
                                                { id: 'personalAssistant', name: 'Personal Assistant' },
                                                { id: 'caregiver', name: 'Caregiver' },
                                                { id: 'elderCareCompanion', name: 'Elder Care Companion' },
                                                { id: 'petSitter', name: 'Pet Sitter' },
                                                { id: 'houseManager', name: 'House Manager' },
                                                { id: 'cleaner', name: 'Cleaner' },
                                                { id: 'maintenanceWorker', name: 'Maintenance Worker' },
                                                { id: 'babySitter', name: 'Baby Sitter' },
                                                { id: 'tutor', name: 'Tutor' },
                                                { id: 'chauffeur', name: 'Chauffeur' },
                                                { id: 'housemaid', name: 'Housemaid' },
                                                { id: 'kitchenStaff', name: 'Kitchen Staff' },
                                                { id: 'diningRoomAttendant', name: 'Dining Room Attendant' },
                                                { id: 'personalChef', name: 'Personal Chef' },
                                                { id: 'eventCoordinator', name: 'Event Coordinator' },
                                                { id: 'householdAdministrator', name: 'Household Administrator' },
                                                { id: 'domesticAssistant', name: 'Domestic Assistant' }
                                            ]
                                                .slice(0, showMoreJobPosition ? 30 : 5)
                                                .map((position) => (
                                                    <div key={position.id} className="form-check">
                                                        <input
                                                            className="form-check-input-allcandidates"
                                                            type="checkbox"
                                                            id={`position-${position.id}`}
                                                            checked={jobPosition[position.id]}
                                                            onChange={(e) => handleJobPositionChange({
                                                                target: {
                                                                    name: position.id,
                                                                    checked: e.target.checked
                                                                }
                                                            })}
                                                        />
                                                        <label className="form-check-label" htmlFor={`position-${position.id}`}>
                                                            {position.name}
                                                        </label>
                                                    </div>
                                                ))}
                                            {30 > 5 && (
                                                <button
                                                    className="btn btn-link p-0 text-decoration-none viewjobposting-text-primary" style={{ textAlign: 'left' }}
                                                    onClick={() => setShowMoreJobPosition(!showMoreJobPosition)}
                                                >
                                                    {showMoreJobPosition ? 'Show Less' : `Show ${30 - 5} More`}
                                                </button>
                                            )}
                                        </div>
                                    )}
                                </div>

                                {/* Job Type Filter */}
                                <div className="mb-4 viewjobposting-filter-section">
                                    <div
                                        className="d-flex flex-row justify-content-between align-items-center cursor-pointer mb-2"
                                        onClick={() => setShowMoreJobType(!showMoreJobType)}
                                    >
                                        <strong>Job Type</strong>
                                        <i className={`bi ${showMoreJobType ? 'bi-chevron-down' : 'bi-chevron-right'}`}></i>
                                    </div>
                                    {showMoreJobType && (
                                        <div className="d-flex flex-column gap-2">
                                            {[
                                                { id: 'fullTime', name: 'Full Time' },
                                                { id: 'partTime', name: 'Part Time' },
                                                { id: 'liveIn', name: 'Live In' },
                                                { id: 'liveOut', name: 'Live Out' },
                                                { id: 'temporary', name: 'Temporary' },
                                                { id: 'permanent', name: 'Permanent' },
                                                { id: 'internship', name: 'Internship' },
                                                { id: 'contractual', name: 'Contractual' },
                                                { id: 'freelance', name: 'Freelance' },
                                                { id: 'volunteer', name: 'Volunteer' },
                                                { id: 'fresher', name: 'Fresher' }
                                            ]
                                                .slice(0, showMoreJobType ? 11 : 5)
                                                .map((type) => (
                                                    <div key={type.id} className="form-check">
                                                        <input
                                                            className="form-check-input-allcandidates"
                                                            type="checkbox"
                                                            id={`jobType-${type.id}`}
                                                            checked={jobType[type.id]}
                                                            onChange={(e) => handleJobTypeChange({
                                                                target: {
                                                                    name: type.id,
                                                                    checked: e.target.checked
                                                                }
                                                            })}
                                                        />
                                                        <label className="form-check-label" htmlFor={`jobType-${type.id}`}>
                                                            {type.name}
                                                        </label>
                                                    </div>
                                                ))}
                                            {11 > 5 && (
                                                <button
                                                    className="btn btn-link p-0 text-decoration-none viewjobposting-text-primary" style={{ textAlign: 'left' }}
                                                    onClick={() => setShowMoreJobType(!showMoreJobType)}
                                                >
                                                    {showMoreJobType ? 'Show Less' : `Show ${11 - 5} More`}
                                                </button>
                                            )}
                                        </div>
                                    )}
                                </div>

                                {/* Contract Status Filter */}
                                <div className="mb-4 viewjobposting-filter-section">
                                    <div
                                        className="d-flex flex-row justify-content-between align-items-center cursor-pointer mb-2"
                                        onClick={() => setShowContractStatus(!showContractStatus)}
                                    >
                                        <strong>Contract Status</strong>
                                        <i className={`bi ${showContractStatus ? 'bi-chevron-down' : 'bi-chevron-right'}`}></i>
                                    </div>
                                    {showContractStatus && (
                                        <div className="d-flex flex-column gap-2">
                                            {[
                                                { id: 'permanent', name: 'Permanent' },
                                                { id: 'temporary', name: 'Temporary' },
                                                { id: 'contract', name: 'Contract' }
                                            ].map((status) => (
                                                <div key={status.id} className="form-check">
                                                    <input
                                                        className="form-check-input-allcandidates"
                                                        type="checkbox"
                                                        id={`contract-${status.id}`}
                                                        checked={contractStatus[status.id]}
                                                        onChange={(e) => handleContractStatusChange({
                                                            target: {
                                                                name: status.id,
                                                                checked: e.target.checked
                                                            }
                                                        })}
                                                    />
                                                    <label className="form-check-label" htmlFor={`contract-${status.id}`}>
                                                        {status.name}
                                                    </label>
                                                </div>
                                            ))}
                                        </div>
                                    )}
                                </div>

                                {/* Posted By Filter */}
                                <div className="mb-4 viewjobposting-filter-section">
                                    <div
                                        className="d-flex flex-row justify-content-between align-items-center cursor-pointer mb-2"
                                        onClick={() => setShowPostedBy(!showPostedBy)}
                                    >
                                        <strong>Post By</strong>
                                        <i className={`bi ${showPostedBy ? 'bi-chevron-down' : 'bi-chevron-right'}`}></i>
                                    </div>
                                    {showPostedBy && (
                                        <div className="d-flex flex-column gap-2">
                                            {[
                                                { id: 'agency', name: 'Agency' },
                                                { id: 'directEmployer', name: 'Direct Employer' }
                                            ].map((post) => (
                                                <div key={post.id} className="form-check">
                                                    <input
                                                        className="form-check-input-allcandidates"
                                                        type="checkbox"
                                                        id={`postedBy-${post.id}`}
                                                        checked={postedBy[post.id]}
                                                        onChange={(e) => handlePostedByChange({
                                                            target: {
                                                                name: post.id,
                                                                checked: e.target.checked
                                                            }
                                                        })}
                                                    />
                                                    <label className="form-check-label" htmlFor={`postedBy-${post.id}`}>
                                                        {post.name}
                                                    </label>
                                                </div>
                                            ))}
                                        </div>
                                    )}
                                </div>

                                {/* Language Filter */}
                                <div className="mb-4 viewjobposting-filter-section">
                                    <div
                                        className="d-flex flex-row justify-content-between align-items-center cursor-pointer mb-2"
                                        onClick={() => setShowMoreLanguage(!showMoreLanguage)}
                                    >
                                        <strong>Language</strong>
                                        <i className={`bi ${showMoreLanguage ? 'bi-chevron-down' : 'bi-chevron-right'}`}></i>
                                    </div>
                                    {showMoreLanguage && (
                                        <div className="d-flex flex-column gap-2">
                                            {[
                                                { id: 'english', name: 'English' },
                                                { id: 'mandarin', name: 'Mandarin' },
                                                { id: 'arabic', name: 'Arabic' },
                                                { id: 'hindi', name: 'Hindi' },
                                                { id: 'tagalog', name: 'Tagalog' },
                                                { id: 'cantonese', name: 'Cantonese' },
                                                { id: 'malay', name: 'Malay' },
                                                { id: 'tamil', name: 'Tamil' }
                                            ]
                                                .slice(0, showMoreLanguage ? 8 : 5)
                                                .map((lang) => (
                                                    <div key={lang.id} className="form-check">
                                                        <input
                                                            className="form-check-input-allcandidates"
                                                            type="checkbox"
                                                            id={`language-${lang.id}`}
                                                            checked={language[lang.id]}
                                                            onChange={(e) => handleLanguageChange({
                                                                target: {
                                                                    name: lang.id,
                                                                    checked: e.target.checked
                                                                }
                                                            })}
                                                        />
                                                        <label className="form-check-label" htmlFor={`language-${lang.id}`}>
                                                            {lang.name}
                                                        </label>
                                                    </div>
                                                ))}
                                            {8 > 5 && (
                                                <button
                                                    className="btn btn-link p-0 text-decoration-none viewjobposting-text-primary" style={{ textAlign: 'left' }}
                                                    onClick={() => setShowMoreLanguage(!showMoreLanguage)}
                                                >
                                                    {showMoreLanguage ? 'Show Less' : `Show ${8 - 5} More`}
                                                </button>
                                            )}
                                        </div>
                                    )}
                                </div>

                                {/* Main Skills Filter */}
                                <div className="mb-4 viewjobposting-filter-section">
                                    <div
                                        className="d-flex flex-row justify-content-between align-items-center cursor-pointer mb-2"
                                        onClick={() => setShowMoreMainSkills(!showMoreMainSkills)}
                                    >
                                        <strong>Main Skills</strong>
                                        <i className={`bi ${showMoreMainSkills ? 'bi-chevron-down' : 'bi-chevron-right'}`}></i>
                                    </div>
                                    {showMoreMainSkills && (
                                        <div className="d-flex flex-column gap-2">
                                            {[
                                                { id: 'childcare', name: 'Childcare' },
                                                { id: 'elderlyCare', name: 'Elderly Care' },
                                                { id: 'cooking', name: 'Cooking' },
                                                { id: 'cleaning', name: 'Cleaning' },
                                                { id: 'laundry', name: 'Laundry' },
                                                { id: 'ironing', name: 'Ironing' },
                                                { id: 'petCare', name: 'Pet Care' },
                                                { id: 'gardening', name: 'Gardening' }
                                            ].map((skill) => (
                                                <div key={skill.id} className="form-check">
                                                    <input
                                                        className="form-check-input-allcandidates"
                                                        type="checkbox"
                                                        id={`skill-${skill.id}`}
                                                        checked={mainSkills[skill.id]}
                                                        onChange={(e) => handleMainSkillsChange({
                                                            target: {
                                                                name: skill.id,
                                                                checked: e.target.checked
                                                            }
                                                        })}
                                                    />
                                                    <label className="form-check-label" htmlFor={`skill-${skill.id}`}>
                                                        {skill.name}
                                                    </label>
                                                </div>
                                            ))}
                                        </div>
                                    )}
                                </div>

                                {/* Start Date Filter */}
                                <div className="mb-4 viewjobposting-filter-section">
                                    <div
                                        className="d-flex flex-row justify-content-between align-items-center cursor-pointer mb-2"
                                        onClick={() => setShowStartDate(!showStartDate)}
                                    >
                                        <strong>Start Date</strong>
                                        <i className={`bi ${showStartDate ? 'bi-chevron-down' : 'bi-chevron-right'}`}></i>
                                    </div>
                                    {showStartDate && (
                                        <div className="p-2 bg-white rounded border">
                                            <input
                                                type="date"
                                                className="form-control"
                                                value={startDate}
                                                onChange={handleStartDateChange}
                                            />
                                        </div>
                                    )}
                                </div>
                                </>
                                )}
                            </div>
                        )}
                    </Col>

                    {/* Candidates List */}
                    <Col md={showFiltersMobile || !isMobile ? 9 : 12} lg={showFiltersMobile || !isMobile ? 10 : 12} className="nurse-results-col">
                        <div className="candidate-toolbar" style={{ marginTop: '20px' }}>
                            <Form className="candidate-toolbar-form" onSubmit={handleSearchSubmit}>
                                <div className="input-group w-100 candidate-search-group">
                                    <Form.Control
                                        type="text"
                                        placeholder={healthcareSearchPlaceholder}
                                        value={searchInput}
                                        onChange={(e) => {
                                            setSearchInput(e.target.value);
                                        }}
                                        className="candidate-search-input"
                                        style={{ minWidth: 0 }}
                                    />
                                    <Button
                                        type="submit"
                                        variant="primary"
                                        className="px-3 candidate-search-button"
                                        style={{ whiteSpace: 'nowrap', flexShrink: 0, minWidth: '78px' }}
                                    >
                                        Search
                                    </Button>
                                </div>
                            </Form>
                            <Button
                                type="button"
                                variant="success"
                                className="candidate-send-alert-button"
                                onClick={handleSendAlertClick}
                            >
                                <HiOutlineBellAlert className="me-2" />
                                Send Bulk Messages
                            </Button>
                        </div>
                        {/* <h2 className="mb-4">Available Candidates ({filteredCandidates.length})</h2> */}
                        {filteredCandidates.length === 0 ? (
                            <div className="text-center no-jobs-message">No candidates match your filters</div>
                        ) : (
                            <>
                                <Row xs={1} sm={2} md={2} lg={3} xl={3} className="nurse-cards-row gx-2 gy-3">
                                    {filteredCandidates.slice(0, visibleCount).map((candidate) => (
                                        <Col key={candidate.id} className="candidate-col">
                                            <CandidateCard
                                                candidate={candidate}
                                                onViewClick={() => handleViewClick(candidate.user_id)}
                                                onContactAction={handleContactAction}
                                                healthcareType={healthcareType}
                                            />
                                        </Col>
                                    ))}
                                </Row>
                                {loadingMore && (
                                    <div className="text-center mt-3">
                                        <div className="spinner-border spinner-border-sm text-primary" role="status">
                                            <span className="visually-hidden">Loading...</span>
                                        </div>
                                    </div>
                                )}
                                {!loadingMore && (visibleCount < filteredCandidates.length || hasMore) && (
                                    <div className="text-center mt-4 mb-3">
                                        <button
                                            className="load-more-btn"
                                            onClick={handleLoadMore}
                                        >
                                            Load More
                                        </button>
                                    </div>
                                )}
                            </>
                        )}
                    </Col>
                </Row>
            </Container>

            <SendAlertScrollPrompt
                pageKey={healthcarePageKey}
                pageLabel={`${healthcarePageLabel} Page`}
                jobPosition={healthcarePageLabel}
                user={user}
                navigate={navigate}
            />

            <GulfWorkerLeadBot pageContext={healthcareType === 'doctor' ? 'Healthcare - Doctor' : 'Healthcare - Nurse'} />
            <Footer />
        </>
    );
}

function CandidateCard({ candidate, onViewClick, onContactAction, healthcareType = 'nurse' }) {
    const isDoctorPage = healthcareType === 'doctor';
    const healthcareLicenseLabel = isDoctorPage ? 'Doctor License' : 'Nursing License';
    const formatDate = (dateString) => {
        if (!dateString) return 'Not specified';
        const date = new Date(dateString);
        const day = date.getDate().toString().padStart(2, '0');
        const months = [
            'January', 'February', 'March', 'April', 'May', 'June',
            'July', 'August', 'September', 'October', 'November', 'December'
        ];
        const month = months[date.getMonth()];
        const year = date.getFullYear();
        return `${day} ${month} ${year}`;
    };

    // Helper function to get languages - with default value
    const getLanguages = () => {
        if (!candidate.language || candidate.language.length === 0) {
            return 'English, Arabic'; // Default value
        }

        // Get language names from the array of objects
        const languages = candidate.language.map(lang => lang.language);

        // If there are 2 or more languages, show the first two
        if (languages.length >= 2) {
            return `${languages[0]}, ${languages[1]}`;
        }

        // If only 1 language exists, just show it
        return languages[0];
    };

    // Helper function to get accommodation preference - with default value
    const getAccommodationPreference = () => {
        if (!candidate.accommodation_preference || candidate.accommodation_preference === 'Not specified') {
            return 'Live in/Live Out'; // Default value
        }
        return candidate.accommodation_preference;
    };

    const getHealthcareLicense = () => {
        const rawSources = isDoctorPage
            ? [
                candidate.dtr_country_doctor_license,
                candidate.nursing_license_countries,
                candidate.nursing_license_country
            ]
            : [candidate.nursing_license_countries, candidate.nursing_license_country];
        let countries = [];
        rawSources.forEach((raw) => {
            try {
                if (Array.isArray(raw)) {
                    countries = [...countries, ...raw];
                } else if (typeof raw === 'string' && raw.trim()) {
                    const parsed = JSON.parse(raw);
                    countries = [...countries, ...(Array.isArray(parsed) ? parsed : [parsed])];
                } else if (raw) {
                    countries = [...countries, raw];
                }
            } catch (e) {
                if (typeof raw === 'string' && raw.trim()) {
                    countries = [...countries, raw];
                }
            }
        });

        const filteredCountries = countries
            .map((country) => {
                if (country && typeof country === 'object') {
                    return country.country_name || country.country || country.license_country;
                }
                return country;
            })
            .filter(country => 
                country && 
                country !== "I Don't have License" && 
                country !== "Not Licensed" &&
                country !== "I don't have driving license"
            );

        const otherLicense = candidate.other_nursing_license_country;
        const hasOtherLicense = otherLicense &&
            otherLicense !== "I Don't have License" &&
            otherLicense !== "Not Licensed" &&
            otherLicense !== "I don't have driving license";

        const combined = [...filteredCountries, hasOtherLicense ? otherLicense : null].filter(Boolean);
        return combined.length > 0 ? combined.join(', ') : 'Not Licensed';
    };

    // Helper function to get available from date - with default value
    const getAvailableFrom = () => {
        const startDate = candidate.preferred_start_date;
        if (!startDate) return 'Immediate'; // Default value

        if (startDate && typeof startDate === 'string' && startDate.toLowerCase().includes('immediate')) return 'Immediate';

        try {
            const date = new Date(startDate);
            if (!isNaN(date.getTime())) {
                return date.toLocaleDateString('en-US', {
                    year: 'numeric',
                    month: 'long',
                    day: 'numeric'
                });
            }
            return startDate;
        } catch (e) {
            return startDate;
        }
    };

    const getMainSkills = () => {
        if (!candidate.main_skills || candidate.main_skills.length === 0) return 'Not specified';
        const firstSkill = candidate.main_skills[0];
        if (firstSkill.includes('["')) {
            try {
                const parsed = JSON.parse(firstSkill.replace(/\\/g, ''));
                if (Array.isArray(parsed)) {
                    return parsed.join(', ');
                }
                return parsed;
            } catch (e) {
                return firstSkill;
            }
        }
        return firstSkill;
    };

    // Handle all actions that require authentication
    const handleAuthAction = (actionType) => {
        onContactAction(actionType, candidate);
    };

    const getCandidateDisplayName = () => {
        const fullNameFromParts = [candidate.first_name, candidate.last_name]
            .filter(Boolean)
            .join(' ')
            .trim();
        const rawName = String(candidate.full_name || candidate.name || fullNameFromParts || '').split('@')[0].trim();
        if (!rawName) return 'Candidate';
        return rawName.charAt(0).toUpperCase() + rawName.slice(1);
    };

    const hasPurchasedTag = hasVisibleOfferBadge(candidate);

    return (
        <Card className="h-100 shadow-sm rounded card-body-home-allcandidate">
            <Card.Body className="d-flex flex-column justify-content-between">
                <CandidateCardHeading candidate={candidate} />
                <div className="d-flex">
                    <div className="me-3 text-center" style={{ marginTop: '15px' }}>
                        <div className="candidate-label-container">
                            {Number(candidate.purchased_badge) === 1 && (
                                <div className="custom-label verified-label">
                                    <span className="verified-label-icon">&#10003;</span>
                                    <span style={{ fontWeight: '600' }}>Verified</span>
                                </div>
                            )}

                            {candidate.verification_status?.toLowerCase() !== "verified" &&
                                candidate.created_at &&
                                moment().diff(moment(candidate.created_at), "days") <= 7 && (
                                    <div className="custom-label" style={{ width: "50%" }}>
                                        New
                                    </div>
                                )}
                        </div>

                        <div className="position-relative d-flex justify-content-center profile-img-container" style={{overflow: 'hidden', borderRadius: '50%', clipPath: 'circle(50%)', width: '100px', height: '100px', transform: 'translateZ(0)'}}>
                            {hasPurchasedTag && (
                                <div className="allcandidates-offer-badge">{getVisibleOfferBadgeText(candidate)}</div>
                            )}
                            {candidate.profile_photo ? (
                                <Image
                                    src={candidate.profile_photo}
                                    loading="lazy"
                                    className="border allcandidate-profile-photo"
                                    alt={`${candidate.first_name || 'Candidate'} profile`}
                                    style={{ width: '100px', height: '100px', objectFit: 'cover', borderRadius: '50%' }}
                                />
                            ) : (
                                <div
                                    className="border allcandidate-profile-photo d-flex align-items-center justify-content-center bg-light rounded-circle overflow-hidden"
                                    style={{ width: '100px', height: '100px' }}
                                >
                                    <Image
                                        src={defaultProfileImage}
                                        className="w-100 h-100"
                                        alt="Default profile"
                                        style={{ objectFit: 'cover' }}
                                    />
                                </div>
                            )}
                        </div>

                        <div className="very-active-label" style={{ color: hasHighlightedSourceLabel(candidate) ? 'green' : '#111', fontWeight: hasHighlightedSourceLabel(candidate) ? '700' : '600' }}>
                            {getVisibleSourceLabel(candidate)}
                        </div>
                    </div>

                    <div className="flex-grow-1 allcandidate-card-right">
                        <h6 className="fw-bold candidate-heading nurse-card-heading">
                            <span style={{ fontWeight: 500 }}>
                                {candidate.first_name
                                    ? candidate.first_name.split("@")[0].charAt(0).toUpperCase() + candidate.first_name.split("@")[0].slice(1)
                                    : ""}
                            </span>
                            <span style={{ fontWeight: 'normal' }}>-{candidate.age}Y- </span>
                            <span style={{ fontWeight: 'normal', color: 'green' }}>{candidate.nationality}</span>
                        </h6>
                        <ul className="small ps-3 mb-0 nursecustom-list nursecandidate-nurse-details">
                            <li>
                                <strong>Name - </strong>
                                {getCandidateDisplayName()}
                            </li>
                            <li>
                                <strong>Job Position - </strong>
                                {Array.isArray(candidate.job_position)
                                    ? candidate.job_position.join(', ').trim() || 'Not specified'
                                    : (candidate.job_position || 'Not specified')}
                            </li>
                            <li className="nurse-license-row">
                                <span className="nurse-license-content">
                                    <strong>{healthcareLicenseLabel} - </strong>
                                    <span className="nurse-license-value">{getHealthcareLicense()}</span>
                                </span>
                            </li>
                            <li>
                                <strong>Salary - </strong>
                                {(() => {
                                    const usdAmount = candidate.expected_monthly_salary_usd
                                        ? parseFloat(candidate.expected_monthly_salary_usd)
                                        : 0;

                                    const localAmount = candidate.expected_monthly_salary
                                        ? parseFloat(candidate.expected_monthly_salary)
                                        : 0;

                                    const qarAmount = candidate.expected_monthly_salary_qar
                                        ? parseFloat(candidate.expected_monthly_salary_qar)
                                        : 0;
                                    if (usdAmount === 0 && localAmount === 0) {
                                        return "Negotiable";
                                    }

                                    let currencyCode = "";
                                    if (candidate.expected_monthly_salary_currency) {
                                        const match = candidate.expected_monthly_salary_currency.match(/^([A-Za-z]{3})/);
                                        currencyCode = match ? match[1] : candidate.expected_monthly_salary_currency.split(' ')[0];
                                    } else if (candidate.nationality) {
                                        const currencyMap = {
                                            "India": "INR",
                                            "Philippines": "PHP",
                                            "Indonesia": "IDR",
                                            "Sri Lanka": "LKR",
                                            "Nepal": "NPR",
                                            "Ghana": "GHS",
                                            "Kenya": "KES",
                                            "Uganda": "UGX",
                                            "Burundi": "BIF",
                                            "Vietnam": "VND",
                                            "Thailand": "THB",
                                            "Cambodia": "KHR",
                                            "Tanzania": "TZS",
                                            "Bangladesh": "BDT",
                                            "Ethiopia": "ETB",
                                            "Sierra Leone": "SLL"
                                        };
                                        currencyCode = currencyMap[candidate.nationality] || "Local";
                                    } else {
                                        currencyCode = "Local";
                                    }

                                    let finalQar = qarAmount;
                                    let finalUsd = usdAmount;

                                    if (finalQar === 0 && localAmount > 0) {
                                        finalQar = localAmount;
                                    }

                                    if (finalUsd === 0 && finalQar > 0) {
                                        finalUsd = finalQar / 3.64;
                                    }

                                    finalQar = Math.round(finalQar);
                                    finalUsd = Math.round(finalUsd);

                                    if (finalQar > 0 && finalUsd > 0) {
                                        return `${finalQar} QAR / ${finalUsd} USD`;
                                    } else if (finalUsd > 0) {
                                        return `${finalUsd} USD`;
                                    } else if (finalQar > 0) {
                                        return `${finalQar} ${currencyCode}`;
                                    }

                                    return "Negotiable";
                                })()}
                            </li>
                            <li>
                                <strong>Experience - </strong>
                                {candidate.total_work_experience || "15 Years"}
                            </li>
                            <li>
                                <strong>Apply for - </strong>{' '}
                                <span>{formatApplyForCountry(candidate.country_apply_for_job)}</span>
                            </li>
                            <li>
                                <strong>Language -</strong> {getLanguages()}
                            </li>
                            <li>
                                <strong>Current Location - </strong>
                                {candidate.current_country || "Not specified"}
                            </li>
                            <li>
                                <strong>Accommodation - </strong>{' '}
                                <span>{getAccommodationPreference()}</span>
                            </li>
                            <li>
                                <strong>Available From - </strong>{' '}
                                <span>{getAvailableFrom()}</span>
                            </li>
                        </ul>
                    </div>
                </div>

                {/* Updated Buttons with authentication */}
                <Row className="mt-1">
                    <Col xs={3} className="px-1">
                        <Button
                            variant="light"
                            className="w-100 small-btn action-button"
                            onClick={() => handleAuthAction('videoCall')}
                        >
                            <FaVideo />
                        </Button>
                    </Col>
                    <Col xs={3} className="px-1">
                        <Button
                            variant="secondary"
                            className="w-100 small-btn action-button gap-2" style={{ backgroundColor: '#7177a6' }}
                            onClick={() => handleAuthAction('call')}
                        >
                            <FaPhoneAlt /> Call
                        </Button>
                    </Col>
                    <Col xs={3} className="px-1">
                        <Button
                            variant="allcandidates-veiwbutton"
                            className="w-100 small-btn action-button gap-2 allcandidates-veiwbutton"
                            onClick={onViewClick}
                        >
                            <FaEye /> View
                        </Button>
                    </Col>
                    <Col xs={3} className="px-1">
                        <Button
                            variant="success"
                            className="w-100 small-btn action-button"
                            onClick={() => handleAuthAction('whatsapp')}
                        >
                            <i className="bi bi-whatsapp" />
                        </Button>
                    </Col>
                </Row>

                <Row className="mt-1 text-center text-muted small fw-medium border-top pt-2 last-buttons-row last-buttons-row-horizontal justify-content-center">
                    <Col xs="auto"
                        className="cursor-pointer no-underline"
                        onClick={() => typeof handleAuthAction !== 'undefined' ? handleAuthAction('wishlist') : onContactAction('wishlist')}
                    >
                        <FaRegHeart className="me-1" /> Like
                    </Col>
                    <Col xs="auto"
                        className="cursor-pointer no-underline"
                        onClick={() => handleAuthAction('share')}
                    >
                        <i className="bi bi-share me-1"></i> Share
                    </Col>
                    <Col xs="auto"
                        className="cursor-pointer no-underline"
                        onClick={() => handleAuthAction('message')}
                    >
                        <i className="bi bi-chat-dots me-1"></i> Message
                    </Col>
                    <Col xs="auto"
                        className="cursor-pointer no-underline"
                        onClick={() => handleAuthAction('report')}
                    >
                        <i className="bi bi-flag me-1"></i> Report
                    </Col>
                </Row>
            </Card.Body>
        </Card>
    );
}

export default Nurse;
